import React, { FunctionComponent, useEffect, useLayoutEffect, useRef } from 'react';

import cn from 'classnames';

import { useActions } from '../../../../shared/hooks';
import { strmPlayerViewingEndedAction } from '../../features/broadcast/slice';
import { VHLivePostMessageEvent } from '../../types';
import classes from './index.css';

interface UgcLiveProps {
    host: string;
    onMessage: (event: VHLivePostMessageEvent) => void;
}

export interface BroadcastViewerPlayerProps {
    playerUrl: string;
    hidden?: boolean;
    ugcLive?: UgcLiveProps | null;
}

const BroadcastViewerPlayer: FunctionComponent<BroadcastViewerPlayerProps> = ({
    hidden = false,
    playerUrl,
    ugcLive,
}) => {
    const { strmPlayerEnded } = useActions({ strmPlayerEnded: strmPlayerViewingEndedAction });
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useLayoutEffect(() => {
        const onMessage = (event: MessageEvent) => {
            if (!iframeRef.current || iframeRef.current.contentWindow !== event.source) {
                return;
            }

            let data;
            try {
                data = JSON.parse(event.data);
            } catch {
                // ignore
            }

            if (data && data.event === 'ended') {
                strmPlayerEnded();
            }
        };

        window.addEventListener('message', onMessage);

        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, [strmPlayerEnded]);

    useEffect(() => {
        if (ugcLive) {
            const { host, onMessage: messageHandler } = ugcLive;
            const onMessage = (event: MessageEvent) => {
                if (!event.origin.includes(host)) {
                    return;
                }

                let data;
                try {
                    data = JSON.parse(event.data);
                } catch {
                    // ignore
                }

                if (data.event === 'contentStatusChanged' || data.event === 'ended') {
                    messageHandler?.(data);
                }
            };

            window.addEventListener('message', onMessage);
            return () => {
                window.removeEventListener('message', onMessage);
            };
        }
    }, [ugcLive]);

    return (
        <div className={cn(classes.BroadcastViewerPlayer, { [classes.BroadcastViewerPlayer_hidden]: hidden })}>
            <iframe
                ref={iframeRef}
                className={classes.BroadcastViewerPlayer__Iframe}
                src={hidden ? '' : playerUrl}
                allow="autoplay; fullscreen; accelerometer; gyroscope; picture-in-picture; encrypted-media"
                allowFullScreen
            />
        </div>
    );
};

export default BroadcastViewerPlayer;
